import { createTranslations } from '@npco/common-utils-translations'

export const exportDebitCardTransactionsModalTranslations = createTranslations({
  title: 'Export transactions',
  exportTransactionsFilename: 'Exported_transactions',
  exportInfo: 'Only approved transactions will be exported.',
})
